import type { TProgressIndicatorVariants } from '~/components/progress-indicator/types'
import type { SnackbarTypes } from '../snackbar.types'

export function progressIndicatorMapper(
  type: SnackbarTypes
): TProgressIndicatorVariants {
  switch (type) {
    case 'info':
      return 'informative'
    case 'success':
    case 'warning':
    case 'danger':
      return type
    default:
      return 'brand'
  }
}
